const metersInKilometer = 1000;

const distanceKmFormatter = (distanceMeters: number): string => {
  if (!distanceMeters || !Number.isInteger(distanceMeters) || distanceMeters <= 0) {
    return '';
  }

  return `${(distanceMeters / metersInKilometer).toFixed()} km`;
};

export default distanceKmFormatter;
